import { createFormContext } from "@mantine/form"
import type { BingoTemplate } from "bingo/types/bingo-template.model"

export const [
  BingoTemplateFormProvider,
  useBingoTemplateFormContext,
  useBingoTemplateForm,
] = createFormContext<Omit<BingoTemplate, "id">>()
